define([
  "backbone",
  "jquery",
  "messaging/messenger",
  "configuration/properties",
  "modules/shared/sortableList/sortableListModel",
], function (Backbone, $, Messenger, Properties, SortableListModel) {
  "use strict";

  const AdvancedConfigurationModel = {};

  AdvancedConfigurationModel.advancedConfiguration = Backbone.Model.extend({
    defaults: {
      name: "",
      value: "",
    },
  });

  AdvancedConfigurationModel.advancedConfigurations = Backbone.AtomicCollection.extend({
    model: AdvancedConfigurationModel.advancedConfiguration,
    comparator: function (a, b) {
      let result = Backbone.textComparator(a, b, "name");
      if (result === 0) {
        result = Backbone.textComparator(a, b, "value");
      }
      return result;
    },
    url: function () {
      const kbId = this.kbId || Messenger.reqres.request("active:kb");
      return `${Properties.rootURL}/${kbId}/config`;
    },
  });

  Messenger.reqres.setHandler("kb:advancedConfiguration:headers", function () {
    const Header = SortableListModel.headerModel;
    return new Backbone.Collection([
      new Header({
        headerName: $.t("admin.kbAdmin.propertyName"),
        modelAttribute: "name",
        longTextField: true,
        filterable: true,
        sortable: true,
      }),
      new Header({
        headerName: $.t("admin.kbAdmin.propertyValue"),
        modelAttribute: "value",
        longTextField: true,
        editable: true,
        filterable: true,
        sortable: true,
      }),
    ]);
  });

  return AdvancedConfigurationModel;
});
